import { notification } from 'antd';
import {
    ExclamationCircleOutlined,
    CheckOutlined
} from '@ant-design/icons';

const sideNotification = {
    open(title, message, isSuccess) {
        var icon = <ExclamationCircleOutlined style={{ color: 'red' }} />;
        if (isSuccess) {
            icon = <CheckOutlined style={{ color: 'green' }} />;
        }

        notification.open({
            message: title,
            description:
                message,
            icon: icon,
            onClick: () => {
            },
        });
    },
}
export default sideNotification